import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const enTranslations = {
  common: {
    add: "Add",
    new: "New",
    save: "Save",
    delete: "Delete",
    cancel: "Cancel",
    search: "Search...",
    home: "Home",
    settings: "Settings",
    profile: "Profile",
    add_user: "Add User",
    id: "ID",
    send: "Send",
    username: "Username",
    email: "Email",
    action: "Action",
    block: "Block",
    unblock: "Unblock",
    time: "Time",
    from: "From",
    to: "To",
    subject: "Subject",
    content: "Content",
    nickname: "Nickname",
    title: "Title",
    user_id: "User ID",
    userid: "User ID",
    user_type: "User Type",
    user_state: "User State",
    admin_state: "Admin State",
    edit: "Edit",
    device_id: "Device ID",
    device_ids: "Device ID(s)",
    push_id: "Push ID",
    push_ids: "Push ID(s)",
    total: "Total",
    export: "Export",
    template: "Template",
    rows_per_page: "Rows per page:",
    ok: "OK",
    success: "Success",
    error: "Error",
    error_msg: "Error Message",
    normal: "Normal",
    blocked: "Blocked",
    revoked: "Revoked",
    deprecated: "Deprecated",
    person: "Person",
    group: "Group",
    bot: "Bot",
    org: "Organization",
    row: "#",
    row: "#",
    userId: "User ID",
    user_id: "User ID",
    userType: "User Type",
    user_type: "User Type",
    userState: "User State",
    user_state: "User State",
    adminState: "Admin State",
    admin_state: "Admin State",
    deviceIds: "Device ID(s)",
    pushIds: "Push ID(s)",
    authCode: "Auth Code",
    registerDate: "Registration Date",
    moreMenu: "More",
    telephone: "Telephone",
    registered: "Registered",
    unregistered: "Unregistered",
    all: "All",
    unknown: "Unknown",
    geo_not_supported: "Geolocation is not supported by your browser",
    locating: "Locating...",
    my_location: "My Location",
    synced: "Synced",
    sync_locations: "Sync Locations",
    no_location_data: "No location data found. Try syncing or check the date range.",
    more_suffix: "more",
    list_empty: "The list is empty",
    no_data_found: "No data found in the database.",
    time: "Time",
    from: "From",
    to: "To",
    subject: "Subject",
    content: "Content",
    timeSent: "Time Sent",
    type: "Type"
  },
  people: {
    search_field: "Search field",
    search_not_found: "No results found for",
    search_not_found_title: "Not found",
    search_try_again: "Try checking for typos or using complete words.",
    edit_title: "Edit {{identity}} info",
    info_title: "{{identity}} Info",
    create_title: "Create New {{identity}}",
    username_req: "Username is required",
    email_req: "Email is required",
    phone_req: "Telephone is required",
    phone_invalid: "Phone number is not valid",
    userid_req: "User ID is required",
    identity_req: "Identity is required",
    password: "Password",
    confirm_password: "Confirm Password",
    account_state: "Account State",
    basic_info_prompt: "Please fill in the basic info",
    fill_info: "Please fill in the basic info",
    userid_exists: "User ID is already registered",
    userid_exists_param: "User ID {{userId}} is already registered",
    email_exists: "Email is already registered",
    email_exists_param: "Email {{email}} is already registered",
    temp_password: "Temporary Password",
    create_btn: "Create {{identity}}",
    confirm_password_req: "Please confirm the password",
    enroll_info_title: "Enroll {{identity}} Info",
    enroll_new_user: "Enroll New User",
    enroll_by_excel: "Batch Enroll (Excel)",
    enroll_success: "Enrolling users successfully",
    enroll_fail: "Failed to register users",
    no_export_data: "No export data",
    send_auth_confirm: "Are you sure to send auth code via email of this user?",
    send_auth_desc: "Email notification with registration auth code will be sent to this user.",
    delete_confirm_title: "Are you sure to delete this {{identity}}?",
    delete_confirm_desc: "This action cannot be undone.",
    delete_cancel: "Deletion of {{identity}} cancelled.",
    auth_code: "Auth Code",
    auth_code_len: "Auth code must be 6 characters",
    send_auth_btn: "Send Auth Code"
  },
  login: {
    email: "Email address",
    password: "Password",
    button: "Login",
    remember: "Remember me",
    forgot: "Forgot password?",
    title: "Sign in",
    email_req: "Email is required",
    email_valid: "Email must be a valid email address",
    password_req: "Password is required",
    password_match: "Passwords do not match"
  },
  theme: {
    label: "Layout Style",
    ocean: "🌊 Oceanic",
    forest: "🌲 Forest",
    sunset: "🌅 Sunset",
    lavender: "🪻 Lavender",
    mint: "🌿 Mint",
    cherry: "🍒 Cherry",
    coffee: "☕ Coffee",
    dark: "🌑 Dark Mode"
  },
  language: {
    label: "Language"
  },
  nav: {
    dashboard: "Dashboard",
    user: "User",
    profile: "Profile",
    admin:   "Admins",
    users:   "Users",
    enroll:  "Enroll",
    contact: "Directory"
  },
  dashboard: {
    title: "Dashboard",
    total_users: "Total Users",
    current_dau: "Current DAU",
    current_mau: "Current MAU",
    messages_protected: "Messages Protected",
    active_users: "Active Users",
    dau: "DAU",
    mau_prev: "MAU of previous month",
    active_timezones: "Active Timezones",
    timezone_subtitle: "active users in different timezones in the last 30 days",
    visits: "visits"
  },
  chatroom: {
    title: "Chatroom",
    search: "Search chats...",
    no_chats: "No chats found",
    type_message: "Type a message...",
    settings: "Settings",
    profile: "Profile",
    privacy: "Privacy",
    about: "About",
    feedback: "Feedback",
    logout: "Logout",
    add_friend: "Add Friend",
    add_group: "Add Group"
  },
  admin: {
    title: "Admins",
    new_admin: "New Admin"
  },
  user: {
    title: "Registered Users",
    new_user: "New User"
  },
  enroll: {
    title: "Enroll New User"
  },
  org: {
    tree_title: "🌳 Organization",
    dept_mgmt: "🏢 Departments",
    people_mgmt: "👤 Users",
    add_dept: "➕ New Department",
    add_user: "➕ New User",
    search_dept: "🔍 Search...",
    search_people: "🔍 Search...",
    total_depts: "Total Departments",
    total_people: "Total People",
    no_parent: "-- No Parent --",
    add_to_group: "➕ Add to Group...",
    remove_confirm: "Remove",
    dept_name_prompt: "Enter department name:",
    rename_dept_prompt: "Modify department name:",
    user_name_prompt: "Enter user name:",
    layout_tb: "Vertical Layout",
    layout_lr: "Horizontal Layout",
    zoom_in: "Zoom In",
    zoom_out: "Zoom Out",
    fit_view: "Fit View",
    remove_edge: "Remove Connection",
    hide_panel: "Hide Panel",
    show_panel: "Show Panel",
    delete_dept_confirm_title: "Delete Department",
    delete_dept_confirm_desc: "Are you sure you want to delete this department and all its sub-departments? This action cannot be undone."
  },
  logout: {
    button: "Logout",
    confirm_title: "Are you sure to Logout?",
    confirm_text: "Logout"
  },
  profile: {
    title: "Server Profile",
    info: "Information",
    conn: "Connection",
    retention: "Retention",
    additional: "Additional",
    name: "Name",
    domain: "Domain",
    org: "Organization",
    api_http: "API Server (Http)",
    api_grpc: "API Server (Grpc)",
    file_http: "File Server (Http)",
    backup_grpc: "Backup Server (Grpc)",
    msg_retention: "Retention days for pending message",
    file_retention: "Retention days for uploaded file",
    user_retention: "Retention days for Inactive users",
    update_link: "Desktop App Update Link",
    theme_color: "Theme color",
    theme_icon: "Theme icon"
  },
  notify: {
    title: "Push Notifications",
    send_title: "Send Push Notification",
    history: "Notification History",
    content: "Content",
    target: "Target",
    type: "Type",
    time: "Time",
    to: "To",
    selected_users: "Selected Users",
    push_id_label: "Push Id",
    all_users: "All Users",
    title_placeholder: "message title",
    sent_success: "Notification sent",
    sent_error: "Send notification failed",
    info_title: "Notification Info"
  },
  history: {
    title: "Message History"
  }
};

const zhTranslations = {
  common: {
    add: "新增",
    new: "新建",
    save: "儲存變更",
    delete: "刪除",
    cancel: "取消",
    search: "搜尋...",
    home: "首頁",
    settings: "設定",
    profile: "個人資料",
    add_user: "新增用戶",
    id: "編號",
    send: "發送",
    username: "姓名",
    email: "電子郵件",
    action: "操作",
    block: "封鎖",
    unblock: "解除封鎖",
    time: "時間",
    from: "來源",
    to: "目標",
    subject: "主題",
    content: "內容",
    nickname: "暱稱",
    title: "職稱",
    user_id: "用戶 ID",
    userid: "用戶 ID",
    user_type: "用戶類型",
    user_state: "用戶狀態",
    admin_state: "管理員狀態",
    edit: "編輯",
    device_id: "設備 ID",
    device_ids: "設備 ID",
    push_id: "推送 ID",
    push_ids: "推送 ID",
    total: "總計",
    export: "匯出資料",
    template: "下載範本",
    rows_per_page: "每頁行數:",
    success: "操作成功",
    error: "錯誤",
    error_msg: "錯誤訊息",
    normal: "正常",
    blocked: "已封鎖",
    revoked: "已撤銷",
    deprecated: "已停用",
    person: "個人",
    group: "群組",
    bot: "機器人",
    org: "組織",
    row: "#",
    userId: "用戶 ID",
    user_id: "用戶 ID",
    userType: "用戶類型",
    user_type: "用戶類型",
    userState: "帳號狀態",
    user_state: "帳號狀態",
    adminState: "管理員狀態",
    admin_state: "管理員狀態",
    deviceIds: "設備 ID",
    pushIds: "推送 ID",
    authCode: "認證碼",
    registerDate: "註冊日期",
    moreMenu: "更多",
    telephone: "電話號碼",
    registered: "已註冊",
    unregistered: "未註冊",
    all: "全部",
    unknown: "未知",
    geo_not_supported: "您的瀏覽器不支援地理位置定位",
    locating: "定位中...",
    my_location: "我的位置",
    synced: "已同步",
    sync_locations: "同步位置",
    no_location_data: "找不到位置資料、請嘗試同步或檢查日期範圍",
    more_suffix: "更多",
    list_empty: "列表目前為空",
    no_data_found: "資料庫中無相關資料",
    time: "時間",
    from: "來源",
    to: "目標",
    subject: "主題",
    content: "內容",
    timeSent: "發送時間",
    type: "類型"
  },
  people: {
    search_field: "搜尋欄位",
    search_not_found: "找不到搜尋結果:",
    search_not_found_title: "無結果",
    search_try_again: "請檢查拼字是否正確或嘗試完整詞彙",
    edit_title: "編輯 {{identity}} 資料",
    info_title: "使用者資料",
    create_title: "建立新 {{identity}}",
    username_req: "請輸入使用者名稱",
    email_req: "請輸入電子郵件",
    phone_req: "請輸入電話號碼",
    phone_invalid: "電話號碼無效",
    userid_req: "請輸入用戶 ID",
    identity_req: "請輸入身分資訊",
    password: "密碼",
    confirm_password: "確認密碼",
    account_state: "帳號狀態",
    basic_info_prompt: "請填寫基本資料",
    fill_info: "請填寫基本資料",
    userid_exists: "用戶 ID 已被註冊",
    userid_exists_param: "用戶 ID {{userId}} 已被註冊",
    email_exists: "電子郵件已被註冊",
    email_exists_param: "電子郵件 {{email}} 已被註冊",
    temp_password: "臨時密碼",
    create_btn: "建立 {{identity}}",
    confirm_password_req: "請確認密碼",
    enroll_info_title: "開通 {{identity}} 資料",
    enroll_new_user: "開通新用戶",
    enroll_by_excel: "整批開通 (Excel)",
    enroll_success: "整批開通用戶成功",
    enroll_fail: "開通失敗",
    no_export_data: "無匯出資料",
    send_auth_confirm: "確定要發送認證碼到該用戶信箱嗎？",
    send_auth_desc: "系統將會發送包含註冊認證碼的郵件給該用戶",
    delete_confirm_title: "您確定要刪除此 {{identity}} 嗎？",
    delete_confirm_desc: "此操作無法復原",
    delete_cancel: "已取消刪除 {{identity}}",
    auth_code: "認證碼",
    auth_code_len: "認證碼必須為 6 位字元",
    send_auth_btn: "發送認證碼"
  },
  login: {
    email: "帳號 (Email)",
    password: "密碼",
    button: "登入",
    remember: "記住我",
    forgot: "忘記密碼？",
    title: "登入系統",
    email_req: "請輸入電子郵件",
    email_valid: "請輸入有效的電子郵件格式",
    password_req: "請輸入密碼",
    password_match: "密碼不符"
  },
  theme: {
    label: "版面風格",
    ocean: "🌊 海洋藍 (預設)",
    forest: "🌲 森林綠",
    sunset: "🌅 日落橘",
    lavender: "💜 薰衣草紫",
    mint: "🌿 薄荷清涼",
    cherry: "🌸 櫻花粉",
    coffee: "☕ 濃縮咖啡",
    dark: "🌑 暗黑模式"
  },
  language: {
    label: "語言"
  },
  nav: {
    dashboard: "儀表板",
    user:    "用戶資訊",
    profile: "伺服器設定",
    admin:   "管理員列表",
    users:   "已註冊用戶",
    enroll:  "開通新帳號",
    contact: "組織通訊錄"
  },
  dashboard: {
    title: "儀表板",
    total_users: "總用戶數",
    current_dau: "當前日活 (DAU)",
    current_mau: "當前月活 (MAU)",
    messages_protected: "受保護訊息數",
    active_users: "活躍用戶",
    dau: "日活躍用戶",
    mau_prev: "上月月活躍用戶",
    active_timezones: "活躍時區分佈",
    timezone_subtitle: "過去 30 天內各時區的活躍用戶數",
    visits: "次訪問"
  },
  chatroom: {
    title: "聊天室",
    search: "搜尋聊天...",
    no_chats: "找不到聊天內容",
    type_message: "輸入訊息...",
    settings: "設定",
    profile: "個人資料",
    privacy: "隱私",
    about: "關於",
    feedback: "回饋",
    logout: "登出",
    add_friend: "新增好友",
    add_group: "新增群組"
  },
  admin: {
    title: "管理員",
    new_admin: "新增管理員"
  },
  user: {
    title: "已註冊用戶",
    new_user: "新增用戶"
  },
  enroll: {
    title: "開通新帳號"
  },
  org: {
    tree_title: "🌳 組織樹",
    dept_mgmt: "🏢 部門管理",
    people_mgmt: "👤 人員管理",
    add_dept: "➕ 新增部門",
    add_user: "➕ 新增人員",
    search_dept: "🔍 搜尋...",
    search_people: "🔍 搜尋...",
    total_depts: "總部門數",
    total_people: "總人數",
    no_parent: "-- 無上層 --",
    add_to_group: "➕ 加入群組...",
    remove_confirm: "移除",
    dept_name_prompt: "請輸入部門名稱:",
    rename_dept_prompt: "修改部門名稱:",
    user_name_prompt: "請輸入人員姓名:",
    layout_tb: "垂直佈局",
    layout_lr: "水平佈局",
    zoom_in: "放大",
    zoom_out: "縮小",
    fit_view: "最適大小",
    remove_edge: "移除連線",
    hide_panel: "隱藏面板",
    show_panel: "顯示面板",
    delete_dept_confirm_title: "刪除部門",
    delete_dept_confirm_desc: "確定要刪除此部門及其所有子部門嗎？此操作無法復原。"
  },
  logout: {
    button: "登出系統",
    confirm_title: "您確定要登出嗎？",
    confirm_text: "登出"
  },
  profile: {
    title: "伺服器設定",
    info: "基本資訊",
    conn: "連線設定",
    retention: "保存期限",
    additional: "其他設定",
    name: "伺服器名稱",
    domain: "網域",
    org: "所屬組織",
    api_http: "API 伺服器 (Http)",
    api_grpc: "API 伺服器 (Grpc)",
    file_http: "檔案伺服器 (Http)",
    backup_grpc: "備份伺服器 (Grpc)",
    msg_retention: "未讀訊息保留天數",
    file_retention: "上傳檔案保留天數",
    user_retention: "閒置用戶保留天數",
    update_link: "桌面版更新連結",
    theme_color: "主題顏色",
    theme_icon: "主題圖示"
  },
  notify: {
    title: "推送通知管理",
    send_title: "發送推送通知",
    history: "通知歷史紀錄",
    content: "訊息內容",
    target: "目標對象",
    type: "類型",
    time: "發送時間",
    to: "發送至",
    selected_users: "指定用戶",
    push_id_label: "推送 ID",
    all_users: "全體用戶",
    title_placeholder: "請輸入訊息標題",
    sent_success: "通知已發送",
    sent_error: "發送通知失敗",
    info_title: "通知詳細資訊"
  },
  history: {
    title: "訊息紀錄"
  }
};

const resources = {
  en: { translation: enTranslations },
  "zh-TW": { translation: zhTranslations },
  "zh-tw": { translation: zhTranslations },
  zh: { translation: zhTranslations }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'zh-TW', 
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
